import { Link } from "react-router-dom";
import styled from "styled-components";

export const CardContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  background-color: var(--black-200);
  width: 25rem;
  min-height: 7rem;
  margin-right: 1rem;
  border-radius: 0.25rem;
  text-decoration: none;
  color: var(--white);
  padding: 1rem;
  margin-bottom: 1rem;

  &:last-of-type {
    margin-bottom: 0;
  }

  > div {
    width: 100%;
  }

  div {
    display: flex;
    flex-direction: row;
  }

  @media (min-width: 1200px) {
    width: 19rem;
    height: 6rem;
    padding: 0.8rem;
  }

  @media (min-width: 1400px) {
    width: 98%;
  }

  @media (min-width: 1920px) {
    width: 100%;
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  border-radius: 0.25rem;
  background-color: var(--black-100);

  span {
    color: var(--primary);
  }

  @media (min-width: 1200px) {
    width: 100px;

    span {
      font-size: 1.3rem;
    }
  }

  @media (min-width: 1400px) {
    span {
      font-size: 1.6rem;
    }
  }

  @media (min-width: 1920px) {
    span {
      font-size: 1.6rem;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0rem 1rem;

  img {
    width: 1.5rem;
    height: 1.5rem;
    transform: rotate(180deg);
  }

  p {
    width: 50%;
  }

  @media (min-width: 1200px) {
    p {
      font-size: 0.9rem;
      width: 80%;
    }

    img {
      width: 1.3rem;
      height: 1.3rem;
    }
  }

  @media (min-width: 1400px) {
    p {
      font-size: 0.9rem;
      width: 100%;
    }
  }

  @media (min-width: 1920px) {
    p {
      font-size: 1rem;
      width: 50%;
    }
  }
`;
